import axios from 'axios';

// Set the base URL for all Axios requests
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// Include credentials with every request (cookies)
axios.defaults.withCredentials = true;

export default axios;
